<template>
  <LoginModal
    class="LoginListOrganisation"
    @close="$emit('close')"
    :title="$t('login.organization.title')"
  >
    <div
      v-if="getRoleByLocalStorage() === ACTUAL_ROLE.TRAINER"
      class="LoginListOrganisation-org"
      v-for="trainer in listOrganizationAvailable(connexion_method)"
      :key="trainer.key"
      @click="selectOrg(trainer)"
    >
      {{ trainer.organization.name }}
    </div>
    <div
      v-if="getRoleByLocalStorage() === ACTUAL_ROLE.SPONSOR"
      class="LoginListOrganisation-org"
      v-for="sponsor in listOrganizationAvailable(connexion_method)"
      :key="sponsor.key"
      @click="selectSponsorOrg(sponsor)"
    >
      {{ sponsor.organization_name }}
    </div>
  </LoginModal>
</template>

<script>
'use strict'

import { mapGetters } from 'vuex'

import LoginModal from '@/components/login/LoginModal'
import { ACTUAL_ROLE, CONNEXION_METHODE } from '@/utils/consts'
import { getRoleByLocalStorage } from '@/utils/function'

export default {
  name: 'LoginListOrganisation',
  components: { LoginModal },
  props: {
    connexion_method: {
      default: null
    },
    selectedOrganizationModalLogin: {
      default: null
    }
  },

  computed: {
    ACTUAL_ROLE() {
      return ACTUAL_ROLE
    },
    ...mapGetters({
      login_data: 'auth/login_data'
    })
  },
  methods: {
    getRoleByLocalStorage,
    selectOrg(trainer) {
      localStorage.setItem('tmpOrganizationId', trainer.organization.id) //for connexion sso
      this.$store
        .dispatch('auth/setLoginOrganization', trainer)
        .then(() => {
          localStorage.removeItem('selectedOrganizationMicrosoft')
          localStorage.removeItem('selectedOrganizationGoogle')
          this.$emit('close')
        })
        .catch(() => {
          this.$emit('close')
        })
    },

    selectSponsorOrg(sponsor) {
      localStorage.removeItem('tmpOrganizationId')
      this.$store
        .dispatch('auth/setLoginOrganization', sponsor)
        .then(() => {
          this.$emit('close')
        })
        .catch(() => {
          this.$emit('close')
        })
    },

    /**
     * return only authorized organization for microsoft, google or password
     * @param {String} connexion_method
     * @returns {Array}
     */
    listOrganizationAvailable(connexion_method) {
      if (getRoleByLocalStorage() === ACTUAL_ROLE.TRAINER) {
        if (connexion_method === CONNEXION_METHODE.SSO_MICROSOFT) {
          return this.login_data.trainers.filter(
            trainer =>
              trainer.login_methods.find(
                login_method => login_method.name === 'azure'
              ) !== undefined
          )
        } else if (connexion_method === CONNEXION_METHODE.SSO_GOOGLE) {
          return this.login_data.trainers.filter(
            trainer =>
              trainer.login_methods.find(
                login_method => login_method.name === 'google'
              ) !== undefined
          )
        } else if (connexion_method === CONNEXION_METHODE.PASSWORD) {
          return this.login_data.trainers.filter(
            trainer =>
              trainer.login_methods.find(
                login_method => login_method.type === 'password'
              ) !== undefined
          )
        } else {
          return this.login_data.trainers.filter(
            trainer =>
              trainer.login_methods.find(
                login_method =>
                  login_method.type === 'sso_on_premises' ||
                  login_method.type === 'pin-code'
              ) !== undefined
          )
        }
      } else if (getRoleByLocalStorage() === ACTUAL_ROLE.SPONSOR) {
        return this.login_data.sponsors.organizations
      }
    }
  },

  mounted() {
    if (this.selectedOrganizationModalLogin) {
      this.selectOrg(this.selectedOrganizationModalLogin[0])
    }
  },

  destroyed() {
    this.$store.dispatch('auth/setConnectionWithPasswordOrPin', null)
  }
}
</script>
<style lang="scss">
.LoginListOrganisation {
  &-org {
    cursor: pointer;
    text-align: center;
    width: 80%;
    font-weight: 500;
    padding: 1.5rem 0;
    border-bottom: 1px solid $border-grey;
    transition-duration: 0.5s;

    &:hover {
      background-color: $hover-grey;
    }
  }
}
</style>
